import React from "react";
import FaqList from "../../components/common/FaqList";
import SEO from "../../components/seo/SEO";

const HelpCenter = () => {
  return (
    <>
      <SEO
        title="Help Center - Instabuild | Frequently Asked Questions"
        description="Find answers to frequently asked questions about Instabuild, Canada's leading building materials platform. Learn about shipping, payments, accounts, and more."
        keywords="help center, FAQ, frequently asked questions, Instabuild help, customer support"
      />
      <FaqList />
    </>
  );
};

export default HelpCenter;
